import * as React from "react";
import { StyledSettingRangeSlider } from "./SettingRangeSlider";
import { Wrapper } from "./Wrapper";

export interface IVolumeSlider {
  volume: number;
  muted: boolean;
  visible: boolean;
  isDragging: boolean;
  onChange: (volume: number) => void;
  setIsDragging(value: boolean): void;
}

export const VolumeSlider = ({
  onChange,
  volume,
  visible,
  muted,
  isDragging,
  setIsDragging
}: IVolumeSlider) => {
  const onChangeVolume = volume => onChange(volume * 0.01);
  const value = muted ? 0 : volume * 100;

  return !visible ? null : (
    <Wrapper>
      <StyledSettingRangeSlider
        onChange={onChangeVolume}
        value={value}
        isDragging={isDragging}
        setIsDragging={setIsDragging}
      />
    </Wrapper>
  );
};
